import React from 'react';
import { Helmet } from 'react-helmet';
import { Alert, Col, Row } from 'react-bootstrap';

export default function EmailSent() {
  return (
    <>
      <Helmet>
        <title>Check Email{process.env.REACT_APP_PAGETITLE_TEXT}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Row>
        <Col></Col>
        <Col xs={12} sm={10} md={8}>
          <br />
          <h2 className="text-center">
            <b>Check your email</b> to complete the Property eAlerts
            subscription process
          </h2>
          <br />
          <Alert variant="success">
            <p className="text-center textup">
              Your Property eAlerts subscription request has been received. To
              complete this process, please check your email and click the link
              found in the email sent from<b> noreply@franklincountyohio.gov</b>.
            </p>
            <p className="text-center textup">
              <b>Please allow 5 to 10 minutes to receive this email.</b>
            </p>
            <p className="text-center textup">
              If you are unable to find the email, please check your spam folder
              and ensure that emails sent from{' '}
              <b>noreply@franklincountyohio.gov</b> are not being blocked by
              your email account.
            </p>
            <p className="text-center textup">
              If you have any questions, please contact the Auditor’s office at
              (614) 525-HOME (4663) during office hours or email{' '}
              <a href="mailto:AuditorStinziano@franklincountyohio.gov?subject=Property eAlerts">
                AuditorStinziano@franklincountyohio.gov
              </a>
              .
            </p>
          </Alert>
        </Col>
        <Col></Col>
      </Row>
    </>
  );
}
